// extracted by mini-css-extract-plugin
export default {"cls1":"AiSummary-cls1___b71b94651d7f05fb3bd","cls2":"AiSummary-cls2__b0bafb5c28b62ffca518 AiSummary-cls1___b71b94651d7f05fb3bd"};